import React, { useState } from 'react';
import { Modal, Box, Button, Typography, FormGroup, FormControlLabel, Checkbox, TextField } from '@mui/material';
import { styleModalInforme } from "../../estilo/modal";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import ProgressBarModal from '../modales/ProgressBar';
import axiosInstancePromise from "../../general/axiosConfig";

const ModalInforme = ({ open, handleClose }) => {
  const [selectedTables, setSelectedTables] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [singleDate, setSingleDate] = useState(false);
  const [saveReport, setSaveReport] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [asunto, setAsunto] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [openModalBar, setOpenModalBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const tablesMap = {
    "Documentos subidos": "DocumentosSubidos",
    "Documentos Procesados": "DocsSubidosProcesados",
    "Contestaciones Pendientes": "Contestaciones",
    "Contestaciones realizadas": "Contestaciones_enviadas"
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSelectedTables(prev =>
      checked ? [...prev, tablesMap[name]] : prev.filter(table => table !== tablesMap[name])
    );
  };

  const handleDownloadReport = async () => {
    if (!selectedTables.length) {
      alert("Debes seleccionar al menos una tabla.");
      return;
    }

    if (!singleDate && (!startDate || !endDate)) {
      alert("Debes seleccionar un rango de fechas.");
      return;
    }
    
    if (sendEmail && !email) {
      alert("Debes ingresar un correo electrónico para enviar el informe.");
      return;
    }

    setOpenModalBar(true);
    setSnackbarMessage('');
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.post("/generar-informe", {
        tables: selectedTables,
        startDate: singleDate ? startDate?.format("YYYY-MM-DD") : startDate?.format("YYYY-MM-DD"),
        endDate: singleDate ? startDate?.format("YYYY-MM-DD") : endDate?.format("YYYY-MM-DD"),
        guardarInforme: saveReport,
        enviarEmail: sendEmail,
        toEmail: email,
        asunto: asunto || "NO",
        mensaje: mensaje || ""
      }, { responseType: 'blob' });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'informe.pdf');
      document.body.appendChild(link);
      link.click();
      handleClose();
      setSnackbarSeverity('success');
    } catch (error) {
      console.error("Error al generar el informe:", error);
      setSnackbarSeverity('error');
      setOpenModalBar(false);
    }
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs} >
        <Modal open={open} onClose={handleClose}>
          <Box sx={styleModalInforme}>
            <Typography variant="h6" component="h2" mb={2} textAlign="center">
              Descargar y/o enviar informe
            </Typography>
            <Typography mb={2}>Escoge las gráficas a incluir en el informe:</Typography>
            <FormGroup>
              {Object.keys(tablesMap).map((label) => (
                <FormControlLabel
                  key={label}
                  control={<Checkbox name={label} onChange={handleCheckboxChange} />}
                  label={label}
                />
              ))}
            </FormGroup>
            
            <Typography mt={2} mb={1}>Selecciona el rango de fechas:</Typography>
            <FormControlLabel
              control={<Checkbox checked={singleDate} onChange={() => setSingleDate(!singleDate)} />}
              label="Filtrar solo por una fecha"
            />
            <DatePicker
              label={singleDate ? "Fecha única" : "Desde"}
              value={startDate}
              onChange={setStartDate}
              format="YYYY-MM-DD"
            />
            {!singleDate && (
              <DatePicker
                label="Hasta"
                value={endDate}
                onChange={setEndDate}
                format="YYYY-MM-DD"
                sx={{ mt: 1 }}
              />
            )}
            
            <FormControlLabel
              control={<Checkbox checked={saveReport} onChange={() => setSaveReport(!saveReport)} />}
              label="Guardar informe en la aplicación"
            />

            <FormControlLabel
              control={<Checkbox checked={sendEmail} onChange={() => setSendEmail(!sendEmail)} />}
              label="Enviar informe por correo"
            />
            {sendEmail && (
              <>
                <TextField fullWidth label="Correo electrónico" value={email} onChange={(e) => setEmail(e.target.value)} sx={{ mt: 2 }} />
                <TextField fullWidth label="Asunto" value={asunto} onChange={(e) => setAsunto(e.target.value)} sx={{ mt: 2 }} />
                <TextField fullWidth label="Mensaje" value={mensaje} onChange={(e) => setMensaje(e.target.value)} sx={{ mt: 2, mb:2, fontSize: "1.1rem" }} multiline rows={7}/>
              </>
            )}

            <Box mt={2} display="flex" justifyContent="center">
              <Button variant="contained" color="primary" onClick={handleDownloadReport} sx={{ background: 'black' }}>
                Descargar/Enviar
              </Button>
            </Box>
          </Box>
        </Modal>
      </LocalizationProvider>
      <ProgressBarModal open={openModalBar} duration={(selectedTables.length * 1000) + 3000}
        message={'Generando informe...'}
        snackbarMessage={snackbarMessage} 
        severity={snackbarSeverity}
        onClose={() => setOpenModalBar(false)}/>
    </>
  );
};

export default ModalInforme;
